<template>
  <v-container>
    <v-row class="justify-center">
      <v-col cols="12" sm="8" md="6" lg="4">
        <v-card class="mt-8">
          <v-card-title class="text-center text-h4 py-4">
            Sign Up
          </v-card-title>
          
          <v-card-text>
            <v-alert
              v-if="error"
              type="error"
              class="mb-4"
            >
              {{ error }}
            </v-alert>

            <v-form @submit.prevent="handleSubmit">
              <v-text-field
                v-model="username"
                label="Username"
                type="text"
                required
                :rules="[v => !!v || 'Username is required']"
                :disabled="loading"
              ></v-text-field>

              <v-text-field
                v-model="password"
                label="Password"
                type="password"
                required
                :rules="[v => !!v || 'Password is required']"
                class="my-4"
                :disabled="loading"
              ></v-text-field>

              <v-text-field
                v-model="confirmPassword"
                label="Confirm Password"
                type="password"
                required
                :rules="[
                  v => !!v || 'Please confirm password',
                  v => v === password || 'Passwords do not match'
                ]"
                class="mb-4"
                :disabled="loading"
              ></v-text-field>

              <v-btn
                color="primary"
                type="submit"
                block
                :loading="loading"
                :disabled="!isValid"
                class="mt-4"
              >
                Sign Up
              </v-btn>

              <div class="text-center mt-4">
                Already have an account?
                <router-link to="/login">Login</router-link>
              </div>
            </v-form>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script setup>
import { ref, computed } from 'vue'
import { useRouter } from 'vue-router'
import { useAuthStore } from '@/stores/authStore'

const router = useRouter()
const authStore = useAuthStore()

const username = ref('')
const password = ref('')
const confirmPassword = ref('')
const loading = ref(false)
const error = ref('')

const isValid = computed(() => {
  return username.value && 
         password.value && 
         confirmPassword.value && 
         password.value === confirmPassword.value
})

const handleSubmit = async () => {
  if (!isValid.value) return
  
  loading.value = true
  error.value = ''
  
  try {
    await authStore.signup(username.value, password.value)
    router.push('/')
  } catch (err) {
    error.value = err.response?.data?.message || 'Failed to create account'
  } finally {
    loading.value = false
  }
}
</script> 